import { put, call, select, takeLatest } from 'redux-saga/effects';
import * as actions from './actions';
import { Endpoints } from 'services/api';
import errorHandler from 'common/errorHandler';

function* getApiKeyEvents(api, apiKeyId) {
    let result = yield call([api, api.get], `${Endpoints.events}/api/v1/apikeys/${apiKeyId}/events`);
    return result.data;
}

export function* getApiKeyEventsRequest(api, { apiKeyId }) {
    try {
        let apiKeyEventsResult = yield call(getApiKeyEvents, api, apiKeyId);
        yield put(actions.getApiKeyEventsSuccess(apiKeyEventsResult));
    } catch (error) {
        let errorObject = errorHandler(error, "Get", "api key events");
        yield put(actions.getApiKeyEventsFailure(errorObject));
    }
}

export function* watchGetApiKeyEventsRequest(api, { params }) {
    yield call(getApiKeyEventsRequest, api, params);
}

export default function* ({ api }) {
    yield takeLatest(actions.GET_API_KEY_EVENTS_REQUEST, watchGetApiKeyEventsRequest, api);
}
